var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white w-56 leading-tight rounded text-xs overflow-hidden rounded shadow-lg"},[_c('h2',{staticClass:"p-1 px-2 bg-gray-900 w-full text-white"},[_c('span',{staticClass:"block font-medium"},[_vm._v(_vm._s(_vm.address))])]),_c('div',{staticClass:"p-1 px-2 bg-white flex w-full gap-3"},[_c('p',[_vm._v(_vm._s(_vm.getType))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }